import { Div } from 'ui'

import CircleColor from 'pages/Flixx/CircleColor'


const Icon = ({ icon: IconSVG }) => (
  <Div
    border='2px solid rgba(255, 255, 255, 0.24)'
    borderRadius={16}
    height={60}
    width={60}
  >
    <Div
      border='1px solid #27272A'
      borderRadius={14}
      backgroundColor='#18181B'
      height='100%'
      width='100%'
      display='grid'
      placeItems='center'
      position='relative'
      overflow='hidden'
    >
      <CircleColor
        opacity={1}
        zIndex={0}
        width={24}
        height={24}
        blur={12}
      />
      <Div zIndex={1} display='grid' >
        <IconSVG height={32} width={32} />
      </Div>
    </Div>
  </Div>
)

export default Icon